import Resizer from "react-image-file-resizer";
import { isUserSuperadmin } from "./auth";
import { get } from "./api";


export const resizeFile = (file) =>
    new Promise((resolve) => {
        let type = file.type || "JPEG";
        if (type === "image/jpg" || type === "image/jpeg") {
            type = "JPEG";
        } else if (type === "image/png") {
            type = "PNG";
        } else {
            type = "JPEG";
        };

        Resizer.imageFileResizer(
            file,
            250,
            400,
            type,
            90,
            0,
            (uri) => {
                resolve(uri);
            },
            "file"
        );
    });


export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};


// Render a stored UTC timestamp (which the API may serialize WITHOUT a 'Z') in the
// user's LOCAL timezone. Pass the raw date string from the API.
export function formatDateTimeLocal(dateStr) {
    if (!dateStr) return '-';
    const s = String(dateStr);
    const iso = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(s) ? s : s + 'Z';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleString(undefined, {
        weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: 'numeric', minute: '2-digit'
    });
}

export async function getBusiness(id) {
    return await get("businesses/business" + (id ? `?business_id=${id}` : ""));
};

export async function getUser() {
    let user = null;
    if (sessionStorage.getItem("user")) {
        return JSON.parse(sessionStorage.getItem("user"));
    }
    try {
        user = await get("users/user");
        if (user) {
            const business = await getBusiness();
            user["business"] = business;
            sessionStorage.setItem("user", JSON.stringify(user));
        }
    } catch (error) {
        console.error(error);
    }
    return user;
};

export async function getUsers(business_id) {
    return await get("users" + (business_id ? `?business_id=${business_id}` : ""));
};

export async function listBusinesses() {
    if (isUserSuperadmin()) {
        return await get("businesses");
    };
};